// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-sidenav .rs-sidenav-nav .rs-sidenav-item i {
  font-size: 14px;
  left: 20px;
  margin-right: 20px;
  position: absolute;
  top: 17px;
}
.portal-sidenav .rs-sidenav-nav .rs-dropdown-item i {
  font-size: 14px;
  left: 30px;
  margin-right: 20px;
  position: absolute;
  top: 15px;
}
.portal-sidenav .rs-sidenav-nav .rs-dropdown-toggle {
  font-size: 14px !important;
  background-color: inherit;
  color: inherit;
}
.portal-sidenav .rs-sidenav-nav > .rs-sidenav-item {
  font-size: 14px;
}
.portal-sidenav .rs-sidenav-nav .rs-dropdown-menu {
  z-index: 100 !important;
  transition: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
